<template>
  <div class="order-processing-page">
    <loader v-if="loading" />
    <template v-else>
      <transition :duration="{ enter: 800, leave: 10 }" name="fade">
        <keep-alive>
          <component :is="currentVisibleComponent" />
        </keep-alive>
      </transition>
      <transition :duration="{ enter: 800, leave: 10 }" name="fade">
        <component :is="currentOtherWindowComponent" />
      </transition>

    <!--    <transition name="fadeUp">
      <comment-keyboard v-show="showCommentKeyboard && currentStep === 2" />
    </transition>-->
    </template>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import CreateClient from '@/components/order-processing/edit-order/create-client/CreateClient'

  import FirstStep from '@/components/order-processing/order-components/FirstStep'
  import SecondStep from '@/components/order-processing/order-components/SecondStep'
  import ThirdStep from '@/components/order-processing/order-components/ThirdStep'

  import ResultStep from '@/components/order-processing/edit-order/result-step/ResultStep'
  import ModificationsWindow from '@/components/order-processing/order-components/modifications-window/ModificationsWindow'
  import CommentariesWindow from '@/components/order-processing/order-components/commentaries-window/CommentariesWindow'
  import PreorderWindow from '@/components/order-processing/order-components/preorder/PreorderWindow'
  import CommentKeyboard from '@/components/order-processing/edit-order/keyboard/CommentKeyboard'
  import PromotionsWindow from '@/components/order-processing/order-components/first-step/PromotionsWindow'
  import HistoryWindow from '@/components/order-processing/order-components/history/HistoryWindow'
  import Loader from '@/components/loader/Loader.vue'
  import snackbarMessage from '@/mixins/snackbar-message'
  import UpsalesWindow from '@/components/order-processing/order-components/upsales/UpsalesWindow.vue'
  import editSessionApi from '@/api/order/edit-session'
  import PaymentMode from '@/models/enums/PaymentMode'
  import PaymentType from '@/models/enums/PaymentType'
  import OrderStatus from '@/models/enums/OrderStatus'

  export default {
    name: 'Orders',
    components: {
      Loader,
      CreateClient,
      FirstStep,
      SecondStep,
      ResultStep,
      ModificationsWindow,
      CommentariesWindow,
      PreorderWindow,
      CommentKeyboard,
      PromotionsWindow,
      HistoryWindow,
    },
    mixins: [
      snackbarMessage,
    ],
    data () {
      return {
        loading: false,
      }
    },
    computed: {
      ...mapState({
        showPromotionsWindow: state => state.fastOrder.showPromotionsWindow,
        currentOtherWindow: state => state.fastOrder.currentOtherWindow,
        currentStep: state => state.fastOrder.currentStep,
        showCommentKeyboard: state => state.fastOrder.showCommentKeyboard,
        basket: state => state.baskets.basket,
        orderId: state => state.fastOrder.orderId,
        allowExitWithoutChekingChanges: state => state.editSession.allowExitWithoutChekingChanges,
        currentEditOrder: state => state.orders.currentEditOrder,
        payNowSelected: state => state.fastOrder.payNowSelected,
      }),
      ...mapGetters({
        isOrderPaid: 'orders/isOrderPaid',
      }),
      // в этой сессии переключили на «оплатить сейчас» и не оплатили - после закрытия формы
      // список заказов откроет диалог оплаты, как после создания
      needsPaymentAfterClose () {
        const order = this.currentEditOrder

        return this.payNowSelected &&
          order?.paymentMode === PaymentMode.PayNow &&
          !this.isOrderPaid &&
          order?.paymentType !== PaymentType.Online &&
          ![OrderStatus.Completed, OrderStatus.Canceled].includes(order?.orderStatus)
      },
      currentOtherWindowComponent () {
        if (this.showPromotionsWindow) {
          return PromotionsWindow
        }
        switch (this.currentOtherWindow) {
          case 'modifications': return ModificationsWindow
          case 'commentaries': return CommentariesWindow
          case 'preorder': return PreorderWindow
          case 'history': return HistoryWindow
          case 'upsales': return UpsalesWindow
        }

        return null
      },
      currentVisibleComponent () {
        if (this.currentOtherWindowComponent) {
          return null
        }

        switch (this.currentStep) {
          case 0: return CreateClient
          case 1: return FirstStep
          case 2: return SecondStep
          case 3: return ThirdStep
        }

        return null
      },
    },
    watch: {
      currentVisibleComponent () {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      },
      currentStep (val) {
        this.$store.commit('fastOrder/closeOtherAndPromoWindows')
      },
      currentOtherWindowComponent () {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      },
      currentOtherWindow (value) {
        if (value && this.showPromotionsWindow) {
          this.$store.commit('fastOrder/togglePromotionsWindow')
        }
      },
      'basket.filial' (filial) {
        console.log('----filial watcher', filial?.id)
        const filialId = filial?.id
        const regionId = filial?.region?.id
        this.$store.commit('app/setRequestFilialId', filialId)
        this.$store.commit('app/setRequestRegionId', regionId)

        if (filialId && this.curFilialId !== filialId) {
          this.curFilialId = filialId
          this.getCategories()
        }
      },
    },
    created () {
      this.resetOrderData()
      this.$store.commit('fastOrder/setPayNowSelected', false)
      // заказ прошлого оформления не должен всплыть в диалоге оплаты после этой сессии
      this.$store.commit('orders/setCurrentOrderInfo', {})
      const orderId = this.$route.query.id
      if (!orderId) {
        this.$router.push('/orders')
      } else {
        // this.$store.commit('fastOrder/setStep', 1)
        this.getOrder(orderId)
        this.getCategories()
      }
    },
    beforeDestroy () {
      if (this.needsPaymentAfterClose) {
        this.$store.commit('orders/setCurrentOrderInfo', this.currentEditOrder)
        this.$store.commit('newOrder/setPaymentMode', PaymentMode.PayNow)
      }
      this.resetOrderData()
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.$store.commit('editSession/setAllowExitWithoutChekingChanges', false)
      })
    },
    beforeRouteLeave (to, from, next) {
      if (this.allowExitWithoutChekingChanges) {
        next()
      } else {
        this.orderId ? this.checkBasketItemsChanges(to, next) : next()
      }
    },
    methods: {
      getCategories () {
        this.$store.commit('fastOrder/setMenuItemsLoading', true)
        // Получаем категории и добавляем их в стор
        this.$store
          .dispatch('categories/fetchFilialMenuCategoriesList', {
            limit: 10000,
            offset: 0,
            page: 1,
            hide_in_crm_items: 0,
          })
          .then((res) => {
            if (res.status === 200 && res.data.items.length) {
              // Добавляем категории в стор
              this.$store.commit('fastOrder/setCategories', res.data.items || [])
              // Добавляем текующую категорию в стор
              this.$store.commit(
                'fastOrder/setCurrentCategory',
                res.data.items[0].id,
              )
              // Добавляем элементы меню в стор
              this.$store.commit(
                'fastOrder/setMenuItemsList',
                res.data.items[0].menuItems,
              )
              // Добавляем коллекции в стор
              this.$store.commit(
                'fastOrder/setCollectionsList',
                res.data.items[0].collections,
              )
            }
          })
          .finally(() => {
            this.$store.commit('fastOrder/setMenuItemsLoading', false)
          })
      },
      getOrder (orderId) {
        this.loading = true
        this.$store.dispatch('orders/fetchSingleOrders', orderId)
          .then(res => {
            const data = res.data.data
            this.$store.commit('baskets/setOrderStatus', data.orderStatus)
            this.$store.commit('orders/setCurrentEditOrder', data)
            this.$store.commit('fastOrder/setOrderId', orderId)
            this.$store.commit('baskets/setBasket', data.basket)
            this.$store.commit('fastOrder/setClientAddress', data.clientAddress)
            this.$store.commit('fastOrder/setOrder', res.data.data)
            this.$store.commit('fastOrder/setStep', 2)
          })
          .catch(e => {
            this.showErrorFromResponse(e)
          })
          .finally(() => {
            this.loading = false
          })
      },
      resetOrderData () {
        this.$store.commit('fastOrder/setStep', 1)
        this.$store.commit('baskets/setOrderStatus', null)
        this.$store.commit('fastOrder/setDrinkDetailsStatus', false)
        this.$store.commit('fastOrder/setSauceDetailsStatus', false)
        this.$store.commit('fastOrder/togglePromotionsWindow', false)
        this.$store.commit('fastOrder/toggleCommentKeyboard', false)
        this.$store.commit('fastOrder/setCurrentOtherWindow', undefined)
        // this.$store.commit('fastOrder/setSecondStepWindow', 'address')
        this.$store.commit('fastOrder/setCurrentPaymentTab', 'paymentTypes')
        this.$store.commit('baskets/setBasket', {})
        this.$store.commit('fastOrder/setMenuItemsList', [])
        this.$store.commit('fastOrder/setCollectionsList', [])
        this.$store.commit('app/setRequestFilialId', null)
        this.$store.commit('app/setRequestRegionId', null)
        this.$store.commit('clients/setClientsAddress', [])
      },
      async checkBasketItemsChanges (to, next) {
        this.$store.commit('editSession/setNextRoute', to)
        this.$store.commit('editSession/setCheckingBasketItemsChanges', true)

        try {
          const response = await editSessionApi.fetchBasketItemsChanges(this.orderId)

          if (response.hasChanges) {
            this.$store.commit('editSession/setShowCorrectionReceiptDialog', true)
            next(false)
          } else {
            try {
              await this.$store.dispatch('editSession/close', this.orderId)
              next()
            } catch (e) {
              this.showErrorFromResponse(e)
            }
          }

          this.$store.commit('editSession/setCheckingBasketItemsChanges', false)
        } catch (e) {
          this.showErrorFromResponse(e)
        }
      },
    },
  }
</script>
